/**
 * 브랜드 공개 API 클라이언트.
 *
 * admin BE 의 BrandController (routes/api.php:578) 와 정합:
 * - GET /api/v1/brands/{brandParam}/stores → 브랜드 정보 + 매장 목록
 *
 * @CODE:BRAND-API-001
 */
import { apiClient, validatePathParam } from './client';
import type { Store } from './types';

export interface BrandStoresResponse {
  success: boolean;
  data: {
    brand: {
      id: number;
      slug: string;
      nickname: string;
      name: Record<string, string> | string;
      logo_url?: string | null;
      organization: {
        id: number;
        slug: string;
        name: Record<string, string> | string;
      };
    };
    stores: Store[];
  };
}

export interface GetStoresByBrandOptions {
  signal?: AbortSignal;
}

export const brandsApi = {
  /**
   * 브랜드별 매장 목록 조회.
   *
   * GET /api/v1/brands/{brandParam}/stores
   * @param brandParam slug, nickname, 또는 numeric id
   * @param organizationId optional — 같은 brandParam 이 여러 조직에 있을 때 분기
   */
  getStoresByBrand: (
    brandParam: string,
    organizationId?: number,
    options?: GetStoresByBrandOptions,
  ) => {
    const safeBrandParam = validatePathParam(brandParam, 'brandParam');
    return apiClient.get<BrandStoresResponse>(
      `/api/v1/brands/${safeBrandParam}/stores`,
      {
        params: organizationId !== undefined ? { organization_id: organizationId } : undefined,
        signal: options?.signal,
      },
    );
  },
};
